<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Serviço</span>
        <h3 class="page-title">Adicionar</h3>
      </d-col>
    </d-row>

    <!-- Content -->
    <d-row>
      <d-col lg="12">
        <service-page />
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import Events from '_utils/events';
import ServicePage from '_modules/service/components/ServicePage.vue';
import { MODEL, _LOAD_MODEL_ } from '../components/ServiceModel';

export default {
  name: 'service-create',
  components: {
    ServicePage,
  },
  created() {
    Events.$emit(_LOAD_MODEL_, MODEL);
    Events.$emit('sidebarVisible', false);
  },
};
</script>

